import React from 'react';
import { CloseOutlined } from '@ant-design/icons';

import { resolveCapabilityIcon } from './capabilityIcons.jsx';

const capabilityMap = (projection) => new Map(
  (Array.isArray(projection?.capabilities) ? projection.capabilities : [])
    .map((item) => [item.target_id, item]),
);

const installationSource = (skill) => String(
  skill.source_domain || skill.source_id || skill.source || '—',
).trim();

export default function SkillDetailDrawer({ onClose, open, projection, skill }) {
  if (!open || !skill) return null;
  const capabilities = capabilityMap(projection);
  return (
    <aside aria-label={`${skill.label || skill.target_id} 详情`} className="flare-skill-detail">
      <header className="flare-skill-detail-header">
        <div>
          <span className="flare-skill-ownership">已安装技能</span>
          <h3>{skill.label || skill.target_id}</h3>
        </div>
        <button aria-label="关闭" className="flare-skill-icon-button" onClick={onClose} type="button">
          <CloseOutlined />
        </button>
      </header>
      <dl className="flare-skill-detail-facts">
        <div><dt>状态</dt><dd>{skill.enabled ? '已启用' : '已停用'}</dd></div>
        <div><dt>调用方式</dt><dd>{skill.enabled ? '自动调用' : '已停用'}</dd></div>
        <div><dt>安装来源</dt><dd>{installationSource(skill)}</dd></div>
        <div><dt>ID</dt><dd>{skill.target_id}</dd></div>
      </dl>
      <div className="flare-skill-detail-section">
        <h4>包含能力</h4>
        <ul>
          {(Array.isArray(skill.capability_ids) ? skill.capability_ids : []).map((capabilityId) => {
            const capability = capabilities.get(capabilityId);
            return (
              <li key={capabilityId}>
                {resolveCapabilityIcon(capability)}
                <span>{capability?.label || capabilityId}</span>
                <span className="flare-skill-ownership">能力</span>
              </li>
            );
          })}
        </ul>
      </div>
    </aside>
  );
}
